<template>
    <div>
        <m-pane
            ref="tablePage"
            class="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            reserveSelection
            unique="mddrTaskNo"
            :currentPage="currentPage"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @searchChange="searchChange"
            @selectChange="selectChange"
            @print-btn="printBtn"
            :searchTotalTitle="config.searchTotalTitle"
            searchId="test"
            pageID="test">
            <div slot="table-module-btn">
                <reportExport #default="{ submit }" reportCode="REPORT-LSP-LMS-RECEPITE-TRANSFER">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'05050203'"><el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button></span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button type="primary" @click="createdOrder" :loading="createdLoading" v-has="'05050201'">生成移交单</el-button>
            </div>
        </m-pane>
    </div>
</template>
<script>
import mPane from '@/components/supplierPanel';
import config from './config.js';
import { getTrueOverList, saveTransfer } from '../../../api/receiptManage';
import reportExport from '@/components/lots/reportExportPlugin';
import dayjs from 'dayjs';
import configs from '@/config/user.env';
import { ConstantsTS } from '../../../constans/constans';
import { maxDay } from '@/modules/transport/tms/common/common';
import common from '../../../common/common';
import { mapGetters } from 'vuex';
import { joinPath } from '@/utils/url';
const { getSessionKey, initSessionData } = common;
const isReceiptTransferQuery = 'Y';
const isCarrierReceiptTransferQuery = 'Y';
export default {
    components: { mPane, reportExport },
    mounted() {
        initSessionData(['SYS_SUPPLIER_YES_NO']);
        // this.$refs.tablePage.$refs.searchList.onSearchChange();
    },
    computed: {
        ...mapGetters(['supplier', 'currentTenant'])
    },
    data() {
        return {
            config,
            totalData: [], // table数据
            pageTotal: 0, // 总条数
            loading: false, // table的loading状态
            currentPage: 1, // 当前页数
            pageSize: 10, // 每页数量
            searchData: {}, // 搜索的对象结果
            exportParams: {},
            isFirstSearch: true,
            createdLoading: false // 生成移交单loading
        };
    },
    methods: {
        _validateSearchParams(data) {
            if (!data.createTimeFrom) {
                return '创建日期不能为空！';
            }
            const beginDate = dayjs(data.createTimeFrom).valueOf() || 0;
            const endDate = dayjs(data.createTimeTo).valueOf() || 0;
            const differenceValue = endDate - beginDate;
            if (differenceValue > maxDay) {
                return '按时间查询或导出时，时间跨度不可超过一个月！';
            }
        },
        _getList(pageNo = 1) {
            const msg = this._validateSearchParams(this.searchData);
            if (msg) return this.$message.warning(msg);
            this.loading = true;
            const {
                SYS_TMS_TANSFER_STATUS,
                SYS_SUPPLIER_YES_NO,
                SYS_TMS_ZTB_FLAG
            } = sessionStorage;
            this.exportParams = {
                mddrCarrierEbcuCode: this.supplier.supplierCode,
                isReceiptTransferQuery,
                isCarrierReceiptTransferQuery,
                ...this.searchData
            };
            getTrueOverList({
                pageNo,
                pageSize: this.pageSize,
                mddrCarrierEbcuCode: this.supplier.supplierCode,
                isReceiptTransferQuery,
                isCarrierReceiptTransferQuery,
                ...this.searchData
            }).then((res) => {
                if (res && res.data && +res.code === 0) {
                    const { list, totalCount, pageNo } = res.data;
                    this.totalData = list.map(item => {
                        // 移交单状态
                        item.mddlStatusType = getSessionKey(item.mddlStatus, SYS_TMS_TANSFER_STATUS);
                        // 是否完好
                        item.mddrIsFullType = getSessionKey(item.mddrIsFull, SYS_SUPPLIER_YES_NO);
                        // 直通宝标识
                        item.ztbzcldType = getSessionKey(item.ztbzcld, SYS_TMS_ZTB_FLAG);
                        return item;
                    });
                    this.pageTotal = totalCount;
                    this.currentPage = +pageNo;
                }
                this.loading = false;
            });
        },
        _saveTransfer() {
            this.createdLoading = true;
            saveTransfer(this.selectArray).then(res => {
                if (res) {
                    if (res.data.success) {
                        const { table, searchList } = this.$refs.tablePage.$refs;
                        this.$message.success('生成移交单成功!');
                        searchList.onSearchChange();
                        table.$refs.moduleTable.clearSelection();
                    } else {
                        this.$message.error(res.data.messagesAsString);
                    }
                }
                this.createdLoading = false;
            });
        },
        pageChange(val) {
            this.currentPage = val;
            this._getList(val);
        },
        sizeChange(val) {
            this.pageSize = val;
            this._getList();
        },
        // 查询结果
        searchChange(val) {
            val = this.formattingData(val);
            this.searchData = val;
            this._getList();
        },
        formattingData(data) {
            const tempData = {
                createTimeFrom: data.createTime && data.createTime.length ? dayjs(data.createTime[0]).format('YYYY-MM-DD HH:mm:ss') : '',
                createTimeTo: data.createTime && data.createTime.length ? dayjs(data.createTime[1]).format('YYYY-MM-DD HH:mm:ss') : '',
                ...data
            };
            delete tempData.createTime;
            return tempData;
        },
        selectChange(data) {
            this.selectArray = data;
        },
        exportFile(submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (!this.isFirstSearch) {
                const msg = this._validateSearchParams(this.searchData);
                if (msg) return this.$message.warning(msg);
            }
            submit({ ...this.exportParams, carrierCode: this.supplier.supplierCode, tenantCode: this.currentTenant.tenantCode });
            this.isFirstSearch = false;
        },
        createdOrder() {
            const data = this.selectArray;
            if (!data.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            for (const item of data) {
                if (item.mddlEttdNo !== null && item.mddlStatus !== null && item.mddlStatus !== ConstantsTS.TANSFER_STATUS_REJECT) {
                    this.$message.error('运输单号' + item.mddrTaskNo + '已生成移交单,不能操作');
                    return false;
                }
            }
            if (data.length > 1) {
                const firstItemKey = data[0].mddrCustomEbcuNameCn;
                const isIdentical = data.every(item => {
                    return item.mddrCustomEbcuNameCn === firstItemKey;
                });
                if (isIdentical) {
                    this._saveTransfer();
                } else {
                    this.$message.error('多选的订单客户名称不同，不可生成移交单');
                }
            } else {
                this._saveTransfer();
            }
        },
        printBtn(row) {
            if (row.mddlEttdNo === '') {
                this.$message.error('移交单号为空,不能打印');
                return false;
            }
            window.open(joinPath(configs.printPDFUrl, `/api-printer/preview?_ignore=true&_report=report_receipt_detailed&ettdNo=${row.mddlEttdNo}`));
        }
    }
};
</script>
<style lang="less">
</style>